
import { useCallback, useReducer } from 'react'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment/moment'

import { Buy } from '../models/buy'
import { buyReducer } from '../reducers/buyReducer'
import { getFinalTotals, getInfoTipoDoc } from '../helpers/compras'

const initialState = {
    detailBuy: {
        id: 0,
        fecha_compra: null,
        fecha_vencimiento: moment(new Date()).add(30, 'days').format('YYYY-MM-DD'),
        numero: '',
        referencia: '',
        id_tipo_documento: null,
        id_forma_pago: null,
        id_moneda: null,
        simbolo: "S/",
        separacion_miles: ",",
        separacion_decimales: ".",
        observaciones: '',
        estado: null,
        id_proveedor: null,
        razon_social: null,
        ruc: null,
        validado: false,
        subtotal: 0,
        descuento: 0,
        monto_base: 0,
        impuesto_porcentaje: 0,
        impuesto_tipo_calculo: null,
        impuesto_nombre: null,
        total_impuesto: 0,
        total_compra: 0,
        total_por_gastar: 0,
        total_pagado: 0,
        total_por_pagar: 0,
        valor_tipo_cambio: 0,
        id_ppto: 0,
        origen: 'ventas',
        origen_referencia: '',
        pagado: false,
        items: [],
        pays: [],
        invoices: [],
        reading_mode: false,
        tipo_gasto: null,
        aplica_detraccion: null,
        porcentaje_detraccion: null,
        total_detraccion: null
    },
    buys: [],
    totals: {
        total_gastado: 0,
        total_pagado: 0,
        total_por_pagar: 0,
    }
}

export const useBuy = () => {

    const [state, dispatch] = useReducer(buyReducer, initialState)
    const { buys, totals, detailBuy } = state

    const initCreateBuy = async (initialParams) => {

        const { origen = 'ventas', itemsSelected, detailBudget, generalParams = null } = initialParams
        const { listaTiposDocumentos = [], detail: paramsDefault } = generalParams

        let newReferencia = 'Nuevo gasto'
        let descriptionOrigenItems = ''
        const idProveedorItem = itemsSelected ? itemsSelected[0]?.id_proveedor : null // obtiene el proveedor del primer item seleccionado

        if (itemsSelected.length === 1) {
            newReferencia = `Gasto para ${itemsSelected[0].nombre}`
            descriptionOrigenItems = `item: ${itemsSelected[0].nombre}`
        }

        if (itemsSelected.length > 1) {
            newReferencia = 'Gasto para varios ítems'
            descriptionOrigenItems = `items: varios`
        }

        let itemsBuy = []
        let totalPorGastar = 0

        for (let x = 0; x < itemsSelected.length; x++) {

            const newId = uuidv4()

            const totalPorGastarItem = parseFloat(itemsSelected[x].total_por_gastar) > 0 ? parseFloat(itemsSelected[x].total_por_gastar) : 0

            const newItem = {
                id: newId,
                nombre: itemsSelected[x].nombre,
                cantidad: 1,
                dias: 1,
                precio_unitario: totalPorGastarItem,
                subtotal: totalPorGastarItem,
                id_titulo: itemsSelected[x].id_titulo,
                id_servicio: itemsSelected[x].id_servicio,
                id_categoria: itemsSelected[x].id_categoria,
                origen: origen,
                tipo: 'item',
                id_item_ppto: itemsSelected[x].id,
                total_por_gastar: totalPorGastarItem,
                create: false
            }

            itemsBuy = [
                ...itemsBuy,
                newItem
            ]

            totalPorGastar += totalPorGastarItem

        }

        const idTipoDoc = itemsSelected[0]?.id_tipo_doc || paramsDefault.id_tipo_documento
        /*  console.log('initCreateBuy----', idTipoDoc) */

        const {
            impuesto_nombre,
            impuesto_porcentaje,
            impuesto_tipo_calculo
        } = await getInfoTipoDoc(listaTiposDocumentos, idTipoDoc)

        let newDetailBuy = {
            ...detailBuy,
            referencia: newReferencia,
            id_proveedor: idProveedorItem,
            fecha_compra: new Date(),
            total_por_gastar: totalPorGastar,

            id_tipo_documento: idTipoDoc,
            impuesto_porcentaje: impuesto_porcentaje,
            impuesto_tipo_calculo: impuesto_tipo_calculo,
            impuesto_nombre: impuesto_nombre,
            id_forma_pago: paramsDefault.id_forma_pago,

            id_moneda: detailBudget.id_moneda,
            simbolo: detailBudget.simbolo,
            separacion_miles: detailBudget.separacion_miles,
            separacion_decimales: detailBudget.separacion_decimales,
            valor_tipo_cambio: (parseInt(detailBudget.id_moneda || 0) === 4 ? detailBudget?.valor_tipo_cambio : 0),
            id_ppto: detailBudget.id,
            origen: origen,
            origen_descripcion_item_ppto: descriptionOrigenItems,
            items: itemsBuy,
            reading_mode: false
        }

        const { sub_total, monto_base, total_impuesto, total_compra } = await getFinalTotals(newDetailBuy, itemsBuy)

        newDetailBuy = {
            ...newDetailBuy,
            subtotal: sub_total,
            monto_base: monto_base,
            total_impuesto: total_impuesto,
            total_compra: total_compra,
        }

        const action = {
            type: '[BUY] set detail',
            payload: newDetailBuy
        }

        dispatch(action)

    }

    const initCreateBuyFromFlow = async (initialParams) => {

        const { origen = 'ventas', itemsSelected, detailBudget, generalParams = null, flowSelected = null } = initialParams
        const { listaTiposDocumentos = [], detail: paramsDefault } = generalParams

        let newReferencia = 'Nuevo gasto'
        let descriptionOrigenItems = ''
        const idProveedorItem = itemsSelected ? itemsSelected[0]?.id_proveedor : null // obtiene el proveedor del primer item seleccionado
        const idDocItem = itemsSelected ? itemsSelected[0]?.id_tipo_documento : null // obtiene del primer item seleccionado

        if (itemsSelected.length === 1) {
            newReferencia = `Gasto para ${itemsSelected[0].nombre}`
            descriptionOrigenItems = `item: ${itemsSelected[0].nombre}`
        }

        if (itemsSelected.length > 1) {
            newReferencia = 'Gasto para varios ítems'
            descriptionOrigenItems = `items: varios`
        }

        let itemsBuy = []
        let totalPorGastar = 0

        for (let x = 0; x < itemsSelected.length; x++) {

            const newId = uuidv4()
            const totalPorGastarItem = parseFloat(itemsSelected[x].total_por_gastar) > 0 ? parseFloat(itemsSelected[x].total_por_gastar) : 0

            const newItem = {
                id: newId,
                nombre: itemsSelected[x]?.nombre,
                cantidad: 1,
                dias: 1,
                precio_unitario: totalPorGastarItem,
                subtotal: totalPorGastarItem,
                id_titulo: itemsSelected[x]?.id_titulo,
                id_servicio: itemsSelected[x]?.id_servicio,
                id_categoria: itemsSelected[x]?.id_categoria,
                origen: origen,
                tipo: 'item',
                id_item_ppto: itemsSelected[x]?.id_item_ppto,
                total_por_gastar: totalPorGastarItem,
                create: false,
                from_title_ppto: true,
                flow_id: itemsSelected[x]?.flow_id
            }

            itemsBuy = [
                ...itemsBuy,
                newItem
            ]

            totalPorGastar += totalPorGastarItem

        }

        const idTipoDoc = idDocItem || paramsDefault.id_tipo_documento

        const {
            impuesto_nombre,
            impuesto_porcentaje,
            impuesto_tipo_calculo
        } = await getInfoTipoDoc(listaTiposDocumentos, idTipoDoc)

        let newDetailBuy = {
            ...detailBuy,
            referencia: newReferencia,
            id_proveedor: idProveedorItem,
            fecha_compra: new Date(),
            total_por_gastar: totalPorGastar,

            id_tipo_documento: idTipoDoc,
            impuesto_porcentaje: impuesto_porcentaje,
            impuesto_tipo_calculo: impuesto_tipo_calculo,
            impuesto_nombre: impuesto_nombre,
            id_forma_pago: paramsDefault.id_forma_pago,

            id_moneda: detailBudget.id_moneda,
            simbolo: detailBudget.simbolo,
            separacion_miles: detailBudget.separacion_miles,
            separacion_decimales: detailBudget.separacion_decimales,
            valor_tipo_cambio: (parseInt(detailBudget.id_moneda || 0) === 4 ? detailBudget?.valor_tipo_cambio : 0),
            id_ppto: detailBudget.id,
            origen: origen,
            origen_descripcion_item_ppto: descriptionOrigenItems,
            items: itemsBuy,
            reading_mode: false,
            flow_id: itemsSelected.length > 1 ? null : flowSelected.id,
            flow_varios: itemsSelected.length > 1 ? true : null,
            aplica_detraccion: null,
            porcentaje_detraccion: null,
            total_detraccion: null
        }

        const { sub_total, monto_base, total_impuesto, total_compra } = await getFinalTotals(newDetailBuy, itemsBuy)

        newDetailBuy = {
            ...newDetailBuy,
            subtotal: sub_total,
            monto_base: monto_base,
            total_impuesto: total_impuesto,
            total_compra: total_compra,
        }

        const action = {
            type: '[BUY] set detail',
            payload: newDetailBuy
        }

        dispatch(action)

    }

    const initGetAllBuy = useCallback(async (filters = {}) => {
        const data = await Buy.getAll(filters)

        dispatch({
            type: '[BUY] Load list',
            payload: data.buys
        });

        dispatch({
            type: '[BUY] Set totals',
            payload: data.totals,
        });

    }, [])

    const initGetOneBuy = useCallback(async (buyId) => {
        const dataOne = await Buy.getOne(buyId)

        const action = {
            type: '[BUY] set detail',
            payload: dataOne
        }

        dispatch(action)

    }, [])

    const initSaveBuy = async (newBuy, loadIniBudget = null) => {
        const resultId = await Buy.save(newBuy)

        const newDetail = {
            ...newBuy,
            id: resultId
        }

        if (resultId) {

            console.log('--loadIniBudget totototo--', loadIniBudget)
            if (loadIniBudget) {
                loadIniBudget()
            }

            const action = {
                type: '[BUY] set detail',
                payload: newDetail
            }

            dispatch(action)

        }

    }

    const initUpdateBuy = async (dataBuy) => {
        await Buy.update(dataBuy)
    }

    const initAnularBuy = async (dataForm) => {
        const dataUpdate = await Buy.updateAnular(dataForm)

        if (dataUpdate.id) {
            const action = {
                type: '[BUY] set detail',
                payload: dataUpdate
            }
            dispatch(action)
        }

    }

    return {
        buys,
        totals,
        detailBuy,
        initGetAllBuy,
        initGetOneBuy,
        initCreateBuy,
        initCreateBuyFromFlow,
        initSaveBuy,
        initUpdateBuy,
        initAnularBuy
    }

}